/* global BigInt */
import { unlockVault } from './walletVault';
import { RELAY_URL, ASSET_DECIMALS, toBaseUnits } from './walletSend';

async function relay(body) {
  const res = await fetch(RELAY_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Relay error');
  return data;
}

const fromB64 = (s) => Uint8Array.from(atob(s), (c) => c.charCodeAt(0));
const toB64 = (bytes) => btoa(String.fromCharCode(...bytes));

// Котирування для екрану підтвердження (без транзакції)
export const getSwapQuote = ({ inputAsset, outputAsset, amount }) =>
  relay({ action: 'swapQuote', inputAsset, outputAsset, amount });

// Мінімум, який юзер гарантовано отримає (outAmount мінус slippage), у базових одиницях
export function minOutUnits(quote) {
  const dec = ASSET_DECIMALS[quote.outputAsset];
  const out = toBaseUnits(quote.outAmount, dec);
  return (out * BigInt(10000 - quote.slippageBps)) / 10000n;
}

export function formatUnits(raw, decimals) {
  const s = BigInt(raw).toString().padStart(decimals + 1, '0');
  const frac = s.slice(-decimals).replace(/0+$/, '');
  return frac ? `${s.slice(0, -decimals)}.${frac}` : s.slice(0, -decimals);
}

// Price impact у %: наш розрахунок для THEO, інакше від Jupiter (-100 = невідомо)
export function quoteImpact(q) {
  if (q.ownPriceImpact !== null && q.ownPriceImpact !== undefined) return q.ownPriceImpact;
  if (typeof q.priceImpact === 'number' && q.priceImpact >= 0) return q.priceImpact;
  return null;
}

// Перевірки + підпис транзакції від Jupiter
export async function signJupiterTx(keypair, base64Tx, expectedFeePayer) {
  const { VersionedTransaction } = await import('@solana/web3.js');
  const tx = VersionedTransaction.deserialize(fromB64(base64Tx));
  const feePayer = tx.message.staticAccountKeys[0].toBase58();
  if (feePayer !== expectedFeePayer) throw new Error('Unexpected transaction: fee payer is not your wallet');
  tx.sign([keypair]);
  return toB64(tx.serialize());
}

// Пароль -> ключ -> СВІЖЕ котирування -> перевірка мінімуму -> підпис -> відправка
export async function executeSwap({ inputAsset, outputAsset, amount, password, keypair: unlockedKeypair, fromAddress, shownQuote }) {
  const keypair = unlockedKeypair || await unlockVault(fromAddress, password);
  if (keypair.publicKey.toBase58() !== fromAddress) throw new Error('Wallet key mismatch');

  const fresh = await relay({ action: 'swapQuote', inputAsset, outputAsset, amount, taker: fromAddress });
  if (!fresh.transaction) throw new Error(fresh.errorMessage || 'Jupiter did not return a transaction');

  const outDec = ASSET_DECIMALS[outputAsset];
  if (toBaseUnits(fresh.outAmount, outDec) < minOutUnits(shownQuote)) {
    throw new Error('Price moved beyond the allowed slippage. Get a new quote.');
  }

  const signedTransaction = await signJupiterTx(keypair, fresh.transaction, fromAddress);
  const res = await relay({
    action: 'swapExecute',
    signedTransaction,
    requestId: fresh.requestId,
    lastValidBlockHeight: fresh.lastValidBlockHeight,
  });
  return { signature: res.signature, outAmount: fresh.outAmount };
}